import React from 'react'
import { BsSearch } from 'react-icons/bs'
import "./Header.css";
import HeaderIcons from './HeaderIcons';
import logoTitan from '../../assets/images/logo/titan-logo.png';
import MainNav from './MainNav';
function Header() {
  return (
    <>
      <header className="header-wrapper">
        <nav className="navbar navbar-expand-lg fixed-top header">
          <div className="container-fluid mx-2 ">
            <img className="navbar-brand logo-titan" src={logoTitan} />
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse " id="navbarSupportedContent">

              <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-1 ">
                <MainNav />
              </ul>
              <div className=" d-flex me-4">
                <ul className="navbar-nav  ms-lg-5 d-inline text-center">
                    <HeaderIcons/>
                </ul> 
              </div>
              <form className="d-flex mt-2" role="search">
                <div className="input-group mb-3">
                  <input type="text" className="form-control py-2 fs13" placeholder="جستجو ..." aria-label="جستجو ..." aria-describedby="basic-addon2" />
                  <span className="input-group-text " id="basic-addon2">
                    <BsSearch className='fs-6' />
                  </span>
                </div>
              </form>
            </div>
          </div>
        </nav>
      </header>

    </>
  )
}

export default Header


